import { useState, useEffect, useCallback } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

interface FetchData<T> {
  data: T | undefined;
  isLoading: boolean;
  error: string | null;
  fetchData: (params?: any) => Promise<T | undefined>;
}

function useFetchData<T>(fetchingMethod: (params?: any) => Promise<AxiosResponse<T>>, fetch?: boolean): FetchData<T> {
  const [data, setData] = useState<T | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async (params?: any): Promise<T | undefined> => {
    setIsLoading(true);
    try {
      const response = await fetchingMethod(params);
      setData(response.data);
      setError(null);
      return response.data;
    } catch (err) {
      setError((err as AxiosError).message);
      setData(undefined);
      return undefined;
    } finally {
      setIsLoading(false);
    }
  }, [fetchingMethod]);

  useEffect(() => {
    if (fetch) {
      fetchData();
    }
  }, [fetch, fetchData]);

  return { data, isLoading, error, fetchData };
}

export default useFetchData;